const TrainerCore = require("../TrainerCore");

const settings = {
	showStarProgress: true,
	canReplayProblem: true,
	canSwitchSet: true,
};

const getLastAvailableIndex = function(result) {
	const numCompleted = result.problems.filter(p => p.outcome).length;
	const numCorrect = result.problems.filter(p => p.outcome === "correct")
		.length;
	const numUnlocked = Math.min(numCorrect, 3);
	return Math.min(numCompleted + numUnlocked, result.problems.length - 1);
};

const getSetProgressInfo = function(result) {
	return {
		viewType: "standard",
		data: {},
	};
};

const shouldIntervene = function(result) {
	return TrainerCore.genericShouldIntervene(result.problems);
};

module.exports = {
	settings,
	getLastAvailableIndex,
	getSetProgressInfo,
	shouldIntervene,
};
